<template>
    <div>
      <div class="header_container mb30">
        <h6 class="--blue70">
          Payment details
        </h6>
      </div>
      <form class="member_wrap">
        <ul>
          <li
              v-for="(field, index_i) in fields"
              :key="index_i"
              :class="field.class"
          >
            <label
                v-for="(item, index_j) in field.items"
                :key="index_j"
                :for="item.id"
                :class="item.id === 'none'? 'visibility_hidden': 'member_input'"
                @click="preventEvent()"
            >
              <input
                  v-if="item.type !== 'select'"
                  :id="item.id"
                  :class="item.class"
                  :type="item.type"
                  :autocomplete="item.autocomplete"
                  :maxlength="item.maxlength"
                  :placeholder="item.placeholder"
                  v-model="item.value"
                  @input="item.inputEvent(item, index_i, index_j)"
                  @blur="item.blurEvent(item, index_i, index_j)"
              >
              <select
                  v-else
                  :id="item.id"
                  :class="item.class"
                  v-model="item.value"
                  @change="item.inputEvent(item, index_i, index_j)"
                  @blur="item.blurEvent(item, index_i, index_j)"
              >
                <option
                    v-for="(option, i) in item.options"
                    :key="i"
                    :value="option.value"
                    :disabled="option.disabled"
                >
                  {{ $t(`${option.label}`) }}
                </option>
              </select>
              <span class="label">{{ $t(`${item.title}`) }}
              <span class="txt_red"> {{ item.required ? '*' : '' }}</span>
              <span
                  v-if="item.guide"
                  class="guide"
              >
                <img
                    v-tooltip="$t(`${item.guide}`)"
                    src="/images/ic/comm/ic-guide.svg"
                    alt=""
                />
              </span>
              </span>
              <span
                  v-if="item.id === 'password' || (!item.validation && item.class.includes(red))"
                  :class="item.class.includes(red) ? 'description red' : 'description'"
              >
              ※ {{ $t(`${item.description}`) }}
          </span>
              <span
                  v-if="item.id === 'cardNo'"
                  :class="handleCardValidation(item.value)? '' : 'opacity-zero'"
                  @click="preventEvent()"
                  class="regular-fill-badge-grey50"
              >{{handleCardValidation(item.value)}}</span>
              <BlindIcon
                v-if="item.id === 'cvc'"
                :index_i="index_i"
                @togglePasswordShow="togglePasswordShow"
              />
            </label>
          </li>
          <div style="display: none">{{ computedAllValidation }}</div>
        </ul>
      </form>
    </div>
</template>
<script>
import validationMethods from '@/common/lib/validation.js'
import BlindIcon from "../../../form/blindIcon";
export default {
  name: 'InputArea',
  components: {BlindIcon},
  data() {
    return {
      red: 'red_wrong',
      fields: [
        {
          index: 0,
          class: 'label_double',
          items: [
            {
              id: 'cardNo',
              class: [],
              title: 'my.payment.details.card_no',
              type: 'cc-number',
              value: '',
              required: true,
              validation: false,
              description: 'my.payment.details.card_no_validation',
              placeholder: '',
              autocomplete: '',
              guide: 'my.payment.details.card_guide',
              minlength: 19,
              maxlength: 19,
              inputEvent: this.checkEachValidation,
              blurEvent: this.checkEachValidation
            },
            {
              id: 'none',
              class: [],
              title: '',
              required: false,
              validation: true
            }
          ]
        },
        {
          index: 1,
          class: 'label_double',
          items: [
            {
              id: 'expiration',
              class: [],
              title: 'my.payment.details.expiration',
              type: 'cc-exp',
              value: '',
              required: true,
              validation: false,
              description: 'my.payment.details.expiration_validation',
              placeholder: 'MMYY',
              autocomplete: '',
              minlength: 4,
              maxlength: 4,
              inputEvent: this.checkEachValidation,
              blurEvent: this.checkEachValidation
            },
            {
              id: 'cvc',
              class: ['input-masking'],
              title: 'my.payment.details.cvc_etc',
              type: 'new-password',
              value: '',
              required: true,
              validation: false,
              description: 'my.payment.details.cvc_etc_validation',
              placeholder: '',
              guide: 'my.payment.details.cvc_guide',
              autocomplete: 'off',
              minlength: 3,
              maxlength: 4,
              inputEvent: this.checkEachValidation,
              blurEvent: this.checkEachValidation
            }
          ]
        },
        {
          index: 2,
          class: 'label_double',
            items: (localStorage.getItem('lang') ?? 'en') === 'ko-kr' ? [
              {
                id: 'lastName',
                class: [],
                title: 'user.last_name',
                type: 'cc-family-name',
                value: '',
                required: true,
                validation: false,
                description: 'account.last_name_validation',
                autocomplete: 'family-name',
                minlength: 1,
                maxlength: 50,
                inputEvent: this.checkEachValidation,
                blurEvent: this.checkEachValidation
              },
              {
                id: 'firstName',
                class: [],
                title: 'user.first_name',
                type: 'cc-given-name',
                value: '',
                required: true,
                validation: false,
                description: 'account.first_name_validation',
                autocomplete: 'given-name',
                minlength: 1,
                maxlength: 50,
                inputEvent: this.checkEachValidation,
                blurEvent: this.checkEachValidation
              },
            ] : [
              {
                id: 'firstName',
                class: [],
                title: 'user.first_name',
                type: 'cc-given-name',
                value: '',
                required: true,
                validation: false,
                description: 'account.first_name_validation',
                autocomplete: 'given-name',
                minlength: 1,
                maxlength: 50,
                inputEvent: this.checkEachValidation,
                blurEvent: this.checkEachValidation
              },
              {
                id: 'lastName',
                class: [],
                title: 'user.last_name',
                type: 'cc-family-name',
                value: '',
                required: true,
                validation: false,
                description: 'account.last_name_validation',
                autocomplete: 'family-name',
                minlength: 1,
                maxlength: 50,
                inputEvent: this.checkEachValidation,
                blurEvent: this.checkEachValidation
              },
            ]
        },
        {
          index: 3,
          class: 'label_double',
          items: [
            {
              id: 'email',
              class: [],
              title: 'user.email',
              type: 'text',
              value: '',
              required: false,
              validation: false,
              description: 'account.email_invalid',
              autocomplete: '',
              minlength: 0,
              maxlength: 100,
              inputEvent: this.checkEachValidation,
              blurEvent: this.checkEachValidation
            },
            {
              id: 'zipCode',
              class: [],
              title: 'my.payment.details.zip_code',
              type: 'text',
              value: '',
              required: true,
              validation: false,
              description: 'my.payment.details.zip_code_validation',
              autocomplete: '',
              minlength: 0,
              maxlength: 10,
              inputEvent: this.checkEachValidation,
              blurEvent: this.checkEachValidation
            }
          ]
        },
        {
          index: 4,
          class: 'relative',
          items: [
            {
              id: 'address',
              class: [],
              title: 'my.payment.details.address',
              type: 'text',
              value: '',
              required: true,
              validation: false,
              description: 'my.payment.details.address_validation',
              guide: 'my.payment.details.address_guide',
              autocomplete: '',
              minlength: 1,
              maxlength: 100,
              inputEvent: this.checkEachValidation,
              blurEvent: this.checkEachValidation
            }
          ]
        }
      ]
    }
  },
  computed: {
    computedAllValidation() {
      let result = true;
      this.fields.forEach(value => {
        value.items.some(({validation}) => {
          if (validation === false) {
            result = validation;
            return !validation;
          }
        });
      });
      return result
    }
  },
  methods: {
    ...validationMethods,
    /**
     *  각 필드를 사용자가 클릭 후 떠나면 (@blur) or (@change, @input)
     *  유효성을 체크한다.
     * @param id
     * @param value
     * @param index_i
     * @param index_j
     */
    checkEachValidation({id, value}, index_i, index_j) {
      let validationCheck = false;
      switch (id) {
        case 'card' :
          validationCheck = true;
          break;
        case 'cardNo' :
          this.fields[index_i].items[index_j].value = this.removeWithoutNum(value);
          validationCheck = this.handleCardValidation(value);
          break;
        case 'expiration' :
          this.fields[index_i].items[index_j].value = this.removeWithoutNum(value);
          if (this.removeWithoutNum(value)) {
            validationCheck = this.checkExpiration(this.removeWithoutNum(value));
          }
          break;
        case 'cvc' :
          this.fields[index_i].items[index_j].value = this.removeWithoutNum(value);
          validationCheck = this.checkCvcValidation(this.removeWithoutNum(value));
          break;
        case 'firstName' :
        case 'lastName' :
          if (!this.removeBlank(value) == '')
            validationCheck = this.checkNameValidation(value);
          break;
        case 'email' : // validation : 공백은 true, 입력이 있으면 유효성 체크
          if (this.removeBlank(value) === '' || this.checkEmailValidation(value))
            validationCheck = true;
          else
            this.fields[index_i].items[index_j].description = 'account.email_form_mismatch';
          break;
        case 'zipCode' :
          validationCheck = this.checkZipCodeValidation(value);
          break;
        case 'address' :
          this.fields[index_i].items[index_j].value = this.removeWithoutNumAndEngAndBlank(value);
          if (!this.removeBlank(value) == '')
            validationCheck = this.checkAddressValidation(value);
          break;
        case 'none' :
          validationCheck = true;
          break;
        default :
          break
      }
      this.changeValidation(validationCheck, index_i, index_j);
    },
    // TODO 결제기능 4번 : 모든 인풋의 밸리데이션 체크
    /**
     * 필수값인데, 입력되지 않은 input 에 빨강 경고 표시
     */
    checkIfNotEntered() {
      let result = true;
      this.fields.forEach((field, index_i) => {
        field.items.forEach((item, index_j) => {
          this.checkEachValidation(item, index_i, index_j);
          if (!item.validation) {
            result = false;
          }
        })
      });
      return result
    },
    /**
     * fields 에 index_i, index_j 에 해당하는 아이템의 유효성 상태와
     * 클래스를 변경한다. (빨강 경고 문구 표기)
     * @param validationCheck
     * @param index_i
     * @param index_j
     */
    changeValidation(validationCheck, index_i, index_j) {
      if (validationCheck) {
        this.fields[index_i].items[index_j].class.removeItem(this.red);
      } else {
        this.fields[index_i].items[index_j].class.pushIfNotExist(this.red)
      }
      this.fields[index_i].items[index_j].validation = validationCheck;
    },
    /**
     * 상위 컴포넌트에서 하위 컴포넌트의 input 데이터를 get
     */
    getFieldsValue() {
      return this.fields
    },
    togglePasswordShow(booleans, index_i) {
      if (booleans) {
        this.fields[index_i].items[1].class.removeItem('input-masking');
      } else {
        this.fields[index_i].items[1].class.pushIfNotExist('input-masking');
      }
    },
    preventEvent() {
      event.preventDefault();
    },
    handleCardValidation(value) {
      return this.checkCardNumValidation(this.removeWithoutNum(value));
    }
  }
}
</script>
<style lang="scss">
  #cardNo {

    /* 카드 밷지 포지션을 위한 코드 */
    & ~ .regular-fill-badge-grey50 {
      position: absolute;
      left: 111%;
      top: 6px;
    }
  }
</style>